import { Box, Typography, useTheme } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation,Trans } from 'react-i18next'
import bgImage from '../../../images/background-circle1.png'
import { createBookingsItem } from './items'

const CreateBookingSection = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const itemsData = createBookingsItem()

  return (
    <Box
      sx={{
        backgroundImage: `url(${bgImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top',
        backgroundSize: 'contain',
      }}
    >
      <Box
        pt={{ xs: 4, md: 10 }}
        mb={{ xs: 5, md: 7 }}
        sx={{
          margin: '0 auto',
          maxWidth: '100rem',
          [theme.breakpoints.up(1900)]: {
            marginTop: 13,
          },
        }}
        paddingBottom='2rem'
      >
        <Typography
          variant='h2'
          sx={{ color: 'publicPages.light' }}
          fontSize={{ xs: '1.5rem', md: '2.5rem' }}
          lineHeight={{ xs: '2.5rem', md: '3.375rem' }}
          fontWeight={600}
        >
          <Trans
            i18nKey='featuresPage.createOnlineText'
            components={{
              highlight: <span style={{ color: theme.palette.publicPages.contrastText }} />,
            }}
          />
        </Typography>
        <Box display='flex' justifyContent={'center'}>
          <Typography
            variant='h5'
            maxWidth={{ xs: 310, sm: 500, md: 640 }}
            sx={{
              color: 'publicPages.main',

              marginTop: '1rem',
              marginBottom: '3.75rem',
              wordBreak: 'break-word',
              [theme.breakpoints.down(350)]: {
                maxWidth: 200,
              },
            }}
            lineHeight={'1.563rem'}
            fontWeight={400}
          >
            {t('featuresPage.guidingUsersText')}
          </Typography>
        </Box>
        <Grid
          container
          rowSpacing={{ xs: 2, sm: 3, md: 5 }}
          columnSpacing={{ sm: 3, md: 1, lg: 3 }}
          display={{ sm: 'inline-flex' }}
          justifyContent='center'
        >
          {itemsData.map((item) => (
            <Grid xs={12} sm={5} md={5} lg={3} key={item.id} display='flex' justifyContent='center'>
              <Box
                key={item.id}
                sx={{
                  width: '17.8rem',
                  height: '13rem',
                  border: `solid 1px ${theme.palette.publicPages.colorFive}`,
                  borderRadius: '1.25rem',
                  textAlign: 'left',
                  padding: '1.25rem',
                  [theme.breakpoints.down(400)]: { margin: '1rem' },
                  backgroundColor: theme.palette.info.main,
                }}
              >
                <Box component='img' src={item.icon} />

                <Typography
                  variant='h3'
                  fontWeight={500}
                  fontSize={'1.1rem'}
                  lineHeight={'1.39'}
                  sx={{ color: 'publicPages.colorDivider' }}
                >
                  {t(`featuresPage.${item.title}`)}
                </Typography>
                <Typography
                  variant='subtitle1'
                  fontWeight={300}
                  lineHeight={'1.5'}
                  sx={{ color: 'publicPages.main', paddingTop: '1rem' }}
                >
                  {t(`featuresPage.${item.description}`)}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  )
}
export default CreateBookingSection
